// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"eb17a1c6","150":"0e310698","488":"6bf0dfa5","508":"298d51c7","521":"65cd70b5","561":"f07423fd","878":"dc7ecde3"}[chunkId] + ".chunk.js";
};